import React from "react";
import AppModal from "../../common/AppModal";
import { Alert } from "@mui/material";
import AdjustStockForm from "../../../forms/AdjustStockForm";

const AdjustStockModal = ({ open, onClose, item, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    loading={loading}
    title="Adjust KRA eTIMS Stock"
    width="xs"
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <AdjustStockForm item={item} loading={loading} />
  </AppModal>
);

export default AdjustStockModal;
